import { createContext } from 'react';
import { PatientContextType } from './types/types';

export const PatientContext = createContext<PatientContextType | undefined>(
  undefined,
);
